<template>
  <div class="nav-container">
    <div class="container">
      <slot ></slot>
    </div>
    <div v-if="barVisible" class="nav-container-inner pt-2">
      <div class="container">
        <b-nav justified>
          <b-nav-item v-if="isHome" active>
            <img srcset='../../assets/image/ic_bottom_home_on@2x.png 2x' class="nav-img">
            <label class="navbar_text">{{$t('menu.home')}}</label>
          </b-nav-item>
          <b-nav-item v-else to="/Home">
            <img srcset='../../assets/image/ic_bottom_home_off@2x.png 2x' class="nav-img">
            <label class="navbar_text">{{$t('menu.home')}}</label>
          </b-nav-item>

          <b-nav-item v-if="isInterest" active>
            <img srcset='../../assets/image/ic_bottom_heart_on@2x.png 2x' class="nav-img">
            <label class="navbar_text">{{$t('menu.interest')}}</label>
          </b-nav-item>
          <b-nav-item v-else to="/Interest">
            <img srcset='../../assets/image/ic_bottom_heart_off@2x.png 2x' class="nav-img">
            <label class="navbar_text">{{$t('menu.interest')}}</label>
          </b-nav-item>

          <b-nav-item v-if="isMap" active>
            <img srcset='../../assets/image/ic_bottom_map_on@2x.png 2x' class="nav-img" style="width: 1rem;height: 1.3rem;">
            <label class="navbar_text">{{$t('menu.map')}}</label>
          </b-nav-item>
          <b-nav-item v-else @click='goMap'>
            <img srcset='../../assets/image/ic_bottom_map_off@2x.png 2x' class="nav-img" style="width: 1rem;height: 1.3rem;">
            <label class="navbar_text">{{$t('menu.map')}}</label>
          </b-nav-item>

          <b-nav-item v-if="isCommunity" active>
            <img srcset='../../assets/image/ic_bottom_community_on@2x.png 2x' class="nav-img" style="width: 1.7rem;height: 1.3rem;">
            <label class="navbar_text">{{$t('menu.community')}}</label>
          </b-nav-item>
          <b-nav-item v-else to="/Community">
            <img srcset='../../assets/image/ic_bottom_community_off@2x.png 2x' class="nav-img" style="width: 1.7rem;height: 1.3rem;">
            <label class="navbar_text">{{$t('menu.community')}}</label>
          </b-nav-item>

          <b-nav-item v-if="isMore" active to="/More">
            <img srcset='../../assets/image/ic_bottom_viewmore_on@2x.png 2x' class="nav-img">
            <label class="navbar_text">{{$t('menu.more')}}</label>
          </b-nav-item>
          <b-nav-item v-else to="/More">
            <img srcset='../../assets/image/ic_bottom_viewmore_off@2x.png 2x' class="nav-img">
            <label class="navbar_text">{{$t('menu.more')}}</label>
          </b-nav-item>
        </b-nav>
      </div>
    </div>
    <b-button  v-if="self.myinfo.isAdmin()&&self.isShopAdmin" variant="white" class="admin_btn admin_btn_label"
               @click='goAdmin'
               >{{$t("admin.show_admin")}}</b-button>
  </div>
</template>

<script>
import {ADMIN_TAB} from "../../config/constant";
export default {
  name: 'Navbar',
  data() {
    return {
      self: this,
      isShopAdmin:this.topMenuVisible,
    }
  },
  props: {
    barVisible:{
      type: Boolean,
      default: true,
    },
    topMenuVisible:{
      type: Boolean,
      default: true,
    }
  },
  inject: ["eventBus"],
  computed: {
    isHome:       vm => vm.$store.getters.tabIndex == vm.$c.MAIN_TAB.HOME,
    isInterest:   vm => vm.$store.getters.tabIndex == vm.$c.MAIN_TAB.INTEREST,
    isMap:        vm => vm.$store.getters.tabIndex == vm.$c.MAIN_TAB.MAP,
    isCommunity:  vm => vm.$store.getters.tabIndex == vm.$c.MAIN_TAB.COMMUNITY,
    isMore:       vm => vm.$store.getters.tabIndex == vm.$c.MAIN_TAB.MORE,
  },
  methods:{
     goMap(){
      this.eventBus.$emit("checkTicketAvailable", () => {
        this.$router.push('/Map');
      });
    },
    goAdmin(){
      if (this.myinfo.phone === '01058403556' || this.myinfo.admin_authority.indexOf(ADMIN_TAB.PENDING_MEMBER) >= 0){
        this.$store.commit('setAdminMode', true);
        this.$router.push('/admin/accept');
      }
      // if (this.myinfo.phone === '01058403556')
      // else
      //   this.$router.push('/admin/member');
    },
    setTopMenu(visible) {
       this.isShopAdmin= visible;
    }
  }
}
//:class="{active: $store.getters.tabIndex == MAIN_TAB.HOME}"
</script>

<style scoped lang="scss">
  @import '../../assets/css/_vars.scss';

  .nav-container {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: white;
    z-index: 100;
  }
  .nav-container-inner {
    background: $c_f7f7f8;
    height: $main_tab_height;
  }
  a.nav-link.active {
    color: $primary;
  }
  a.nav-link {
    display: flex;
    flex-direction: column;
    align-items: center;
    color: $c_727373;
  }
</style>



// WEBPACK FOOTER //
// src/components/controls/navbar.vue